export default "__VITE_ASSET__c4731b67__"